"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _numberFormatter = require("../../helpers/numberFormatter");
var level1DataProp = _interopRequireWildcard(require("../../propTypes/level1Data"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _instrumentPropTypes = require("../../propTypes/instrumentPropTypes");
var _InstrumentTableItem = _interopRequireDefault(require("./InstrumentTableItem"));
var _InstrumentTableItems = _interopRequireDefault(require("./InstrumentTableItems"));
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
require("./InstrumentTableComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var InstrumentTableComponent = function InstrumentTableComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)('core'),
    t = _useTranslation.t;
  var level1 = props.level1,
    selectedInstrument = props.selectedInstrument,
    items = props.items,
    customClass = props.customClass,
    decimalPlacesP2 = props.decimalPlacesP2;
  var baseClasses = (0, _cssClassesHelper.getBEMClasses)(['instrument-table', customClass]);
  var product1Symbol = selectedInstrument.Product1Symbol;
  var product2Symbol = selectedInstrument.Product2Symbol;
  var instrumentTableItems = (0, _react.useMemo)(function () {
    return items.map(function (item) {
      return level1ItemsData[item.field](t, level1, selectedInstrument, decimalPlacesP2);
    });
  }, [decimalPlacesP2, items, level1, selectedInstrument, t]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses()
  }, customClass === 'market-overview-instrument' && /*#__PURE__*/_react["default"].createElement("div", {
    className: baseClasses('row')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: baseClasses('title')
  }, t('{{venueSymbol}} Price Data', {
    venueSymbol: "".concat(product1Symbol).concat(product2Symbol)
  }), ":")), instrumentTableItems.map(function (_ref) {
    var key = _ref.key,
      value = _ref.value,
      label = _ref.label,
      classModifiers = _ref.classModifiers;
    return /*#__PURE__*/_react["default"].createElement(_InstrumentTableItem["default"], {
      key: key,
      value: value,
      label: label,
      baseClasses: baseClasses,
      classModifiers: classModifiers
    });
  }));
};
InstrumentTableComponent.propTypes = {
  level1: level1DataProp.type.isRequired,
  selectedInstrument: _instrumentPropTypes.instrumentPropType,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    field: _propTypes["default"].string.isRequired
  }))
};
InstrumentTableComponent.defaultProps = {
  level1: level1DataProp.defaultProps,
  items: [{
    field: _InstrumentTableItems["default"].lastPrice
  }, {
    field: _InstrumentTableItems["default"].dailyPercentageChange
  }, {
    field: _InstrumentTableItems["default"].bid
  }, {
    field: _InstrumentTableItems["default"].ask
  }, {
    field: _InstrumentTableItems["default"].dailyVolume
  }, {
    field: _InstrumentTableItems["default"].dailyMin
  }, {
    field: _InstrumentTableItems["default"].dailyMax
  }]
};
var _default = exports["default"] = InstrumentTableComponent;
var level1ItemsData = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, _InstrumentTableItems["default"].lastPrice, function (t, _ref2, instrument) {
  var LastTradedPx = _ref2.LastTradedPx;
  return {
    key: _InstrumentTableItems["default"].lastPrice,
    value: (0, _numberFormatter.formatNumberToLocale)(LastTradedPx, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.PriceIncrement)),
    label: t('Last Price'),
    classModifiers: ['last-price']
  };
}), _InstrumentTableItems["default"].dailyPercentageChange, function (t, _ref3) {
  var Rolling24HrPxChangePercent = _ref3.Rolling24HrPxChangePercent;
  return {
    key: _InstrumentTableItems["default"].dailyPercentageChange,
    value: (0, _numberFormatter.formatPercentageValue)(Rolling24HrPxChangePercent),
    label: t('24 Hour Pct Chg'),
    classModifiers: [Rolling24HrPxChangePercent >= 0 ? '24h-positive' : '24h-negative']
  };
}), _InstrumentTableItems["default"].bid, function (t, _ref4, _instrument, decimalPlacesP2) {
  var BestBid = _ref4.BestBid;
  return {
    key: _InstrumentTableItems["default"].bid,
    value: (0, _numberFormatter.formatNumberToLocale)(BestBid, decimalPlacesP2),
    label: t('Bid'),
    classModifiers: ['hideable', 'bid']
  };
}), _InstrumentTableItems["default"].ask, function (t, _ref5, _instrument, decimalPlacesP2) {
  var BestOffer = _ref5.BestOffer;
  return {
    key: _InstrumentTableItems["default"].ask,
    value: (0, _numberFormatter.formatNumberToLocale)(BestOffer, decimalPlacesP2),
    label: t('Ask'),
    classModifiers: ['hideable', 'ask']
  };
}), _InstrumentTableItems["default"].dailyVolume, function (t, _ref6, instrument) {
  var Rolling24HrVolume = _ref6.Rolling24HrVolume;
  return {
    key: _InstrumentTableItems["default"].dailyVolume,
    value: "".concat((0, _numberFormatter.formatNumberToLocale)(Rolling24HrVolume, (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(instrument.QuantityIncrement)), " ").concat(instrument.Product1Symbol),
    label: t('24 Hour Volume'),
    classModifiers: ['24h-volume']
  };
}), _InstrumentTableItems["default"].dailyMin, function (t, _ref7, _instrument, decimalPlacesP2) {
  var SessionLow = _ref7.SessionLow;
  return {
    key: _InstrumentTableItems["default"].dailyMin,
    value: (0, _numberFormatter.formatNumberToLocale)(SessionLow, decimalPlacesP2),
    label: t('24 Hour Low'),
    classModifiers: ['hideable', '24h-low']
  };
}), _InstrumentTableItems["default"].dailyMax, function (t, _ref8, _instrument, decimalPlacesP2) {
  var SessionHigh = _ref8.SessionHigh;
  return {
    key: _InstrumentTableItems["default"].dailyMax,
    value: (0, _numberFormatter.formatNumberToLocale)(SessionHigh, decimalPlacesP2),
    label: t('24 Hour High'),
    classModifiers: ['hideable', '24h-high']
  };
});